// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kLBR0","tabsBox":"styles_tabsBox__1aP80","createButton":"styles_createButton__dWTqq"};